import React from "react";
import {
  NumberInput,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  Create,
  SimpleForm,
  useNotify,
} from "react-admin";
import { errorHandlingFactory } from "../../_myBase/utils/errors";

export default function HostTowersCreate(props) {
  const notify = useNotify();
  const onError = errorHandlingFactory(notify);

  return (
    <Create {...props} redirect={false} mutationOptions={{ onError }}>
      <SimpleForm>
        <NumberInput
          source="user_id"
          parse={(v) => (typeof v === "string" ? v.trim() : v)}
        />
        <ArrayInput source="tower_ids">
          <SimpleFormIterator>
            <TextInput source="" label="Tower ID" parse={(v) => v?.trim()} />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
}
